import { colors } from '../../../../healtheraComponents';
import styled from 'styled-components';
import { StyledSwitch as Switch } from '../../PlusWebsiteEditor.styles';

export const StyledSwitch = styled(Switch)`
  margin-left: auto;
`;

export const StyledName = styled.p`
  margin: 0;
  margin-left: 10px;
`;

export const StyledHomepageSectionContainer = styled.div`
  padding: 10px;
  margin-top: 10px;
  border-radius: 5px;
  gap: 10px;
  background-color: ${colors.GRAY_LIGHTER};
  display: flex;
  align-items: center;
`;
